import React from "react";
import { View, Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import AppInput from "../shared/AppInput";
import { TextLink } from "./TextLink";
import tw from "twrnc";
import HelpTip from "@/components/settings/HelpTip";
import { text as settingsText } from "@/components/settings/theme";
import { t } from "@/localization";

// align "left" + helpTopic: the event settings look. Default: the create-event
// forms' right-aligned "Multi-Day event?" link.
const MultiDaySelector = ({
  f,
  questionStyle,
  align = "right",
  helpTopic,
  linkText,
}) => {
  return (
    <View style={tw``}>
      {f.values.days <= 1 && (
        <View
          style={tw`flex-row items-center ${
            align === "left" ? "justify-start" : ""
          }`}
        >
          <TextLink
            text={linkText || t("Multi-Day event?")}
            onPress={() => {
              f.setFieldValue("days", 2, true);
            }}
            style={align === "left" ? undefined : tw`flex-1`}
            textStyle={
              align === "left"
                ? [settingsText.link, tw`py-2`, questionStyle]
                : [tw`py-2.5 text-right w-full`, questionStyle]
            }
          />
          {!!helpTopic && <HelpTip topic={helpTopic} />}
        </View>
      )}
      {(f.values.days > 1 || f.errors.days) && (
        <AppInput
          onBlur={f.handleBlur("days")}
          value={String(f.values.days)}
          onChangeText={f.handleChange("days")}
          label={t("Days")}
          inputStyle={tw`ml-2`}
          labelStyle={tw`ml-0`}
          errorMessage={f.errors.days && f.touched.days ? f.errors.days : null}
          rightComponent={
            <View style={tw`flex flex-row gap-2`}>
              <Pressable
                onPress={() => {
                  f.setFieldValue("days", Math.max(1, f.values.days - 1), true);
                }}
              >
                <Ionicons
                  name="remove-outline"
                  size={24}
                  style={tw`text-[#8B8B8D]`}
                />
              </Pressable>
              <Pressable
                onPress={() => {
                  f.setFieldValue("days", Math.min(7, f.values.days + 1), true);
                }}
              >
                <Ionicons name="add" size={24} style={tw`text-[#8B8B8D]`} />
              </Pressable>
            </View>
          }
        />
      )}
    </View>
  );
};

export default MultiDaySelector;
